import { c as _c } from "react/compiler-runtime";
// eslint-disable-next-line no-restricted-imports -- This is the only place where useMediaQuery is needed
import { useMediaQuery, useTheme } from "@mui-wrapper";
import { XXXL_BREAKPOINT } from "@styles/common-styles";
import { getIsHoverSupported } from "@utils/ui-utils";
/** Hook to get the current media query state */
export function useMediaQueryList() {
  const $ = _c(49);
  const theme = useTheme();
  let t0;
  if ($[0] !== theme.breakpoints) {
    t0 = theme.breakpoints.only("xs");
    $[0] = theme.breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isScreenXs = useMediaQuery(t0);
  let t1;
  if ($[2] !== theme.breakpoints) {
    t1 = theme.breakpoints.only("sm");
    $[2] = theme.breakpoints;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isScreenSm = useMediaQuery(t1);
  let t2;
  if ($[4] !== theme.breakpoints) {
    t2 = theme.breakpoints.down("md");
    $[4] = theme.breakpoints;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isScreenSmOrSmaller = useMediaQuery(t2);
  let t3;
  if ($[6] !== theme.breakpoints) {
    t3 = theme.breakpoints.up("sm");
    $[6] = theme.breakpoints;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const isScreenSmOrLarger = useMediaQuery(t3);
  let t4;
  if ($[8] !== theme.breakpoints) {
    t4 = theme.breakpoints.only("md");
    $[8] = theme.breakpoints;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const isScreenMd = useMediaQuery(t4);
  let t5;
  if ($[10] !== theme.breakpoints) {
    t5 = theme.breakpoints.down("lg");
    $[10] = theme.breakpoints;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const isScreenMdOrSmaller = useMediaQuery(t5);
  let t6;
  if ($[12] !== theme.breakpoints) {
    t6 = theme.breakpoints.up("md");
    $[12] = theme.breakpoints;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const isScreenMdOrLarger = useMediaQuery(t6);
  let t7;
  if ($[14] !== theme.breakpoints) {
    t7 = theme.breakpoints.only("lg");
    $[14] = theme.breakpoints;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const isScreenLg = useMediaQuery(t7);
  let t8;
  if ($[16] !== theme.breakpoints) {
    t8 = theme.breakpoints.down("xl");
    $[16] = theme.breakpoints;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const isScreenLargeOrSmaller = useMediaQuery(t8);
  let t9;
  if ($[18] !== theme.breakpoints) {
    t9 = theme.breakpoints.up("lg");
    $[18] = theme.breakpoints;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const isScreenLgOrLarger = useMediaQuery(t9);
  let t10;
  if ($[20] !== theme.breakpoints) {
    t10 = theme.breakpoints.only("xl");
    $[20] = theme.breakpoints;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const isScreenXl = useMediaQuery(t10);
  let t11;
  if ($[22] !== theme.breakpoints) {
    t11 = theme.breakpoints.down("xxl");
    $[22] = theme.breakpoints;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const isScreenXlOrSmaller = useMediaQuery(t11);
  let t12;
  if ($[24] !== theme.breakpoints) {
    t12 = theme.breakpoints.up("xl");
    $[24] = theme.breakpoints;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const isScreenXlOrLarger = useMediaQuery(t12);
  let t13;
  if ($[26] !== theme.breakpoints) {
    t13 = theme.breakpoints.only("xxl");
    $[26] = theme.breakpoints;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const isScreenXXL = useMediaQuery(t13);
  const isScreenXXLOrSmaller = useMediaQuery(theme.breakpoints.down("xxl")) || isScreenXXL;
  let t14;
  if ($[28] !== theme.breakpoints) {
    t14 = theme.breakpoints.up("xxl");
    $[28] = theme.breakpoints;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const isScreenXXLOrLarger = useMediaQuery(t14);
  const isScreenXXXL = useMediaQuery(`(min-width: ${XXXL_BREAKPOINT}px)`);
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = getIsHoverSupported();
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  const isHoverSupported = t15;
  let t16;
  if ($[31] !== isScreenLargeOrSmaller || $[32] !== isScreenLg || $[33] !== isScreenLgOrLarger || $[34] !== isScreenMd || $[35] !== isScreenMdOrLarger || $[36] !== isScreenMdOrSmaller || $[37] !== isScreenSm || $[38] !== isScreenSmOrLarger || $[39] !== isScreenSmOrSmaller || $[40] !== isScreenXXL || $[41] !== isScreenXXLOrLarger || $[42] !== isScreenXXLOrSmaller || $[43] !== isScreenXXXL || $[44] !== isScreenXl || $[45] !== isScreenXlOrLarger || $[46] !== isScreenXlOrSmaller || $[47] !== isScreenXs) {
    t16 = {
      isScreenXs,
      isScreenSm,
      isScreenSmOrSmaller,
      isScreenSmOrLarger,
      isScreenMd,
      isScreenMdOrSmaller,
      isScreenMdOrLarger,
      isScreenLg,
      isScreenLargeOrSmaller,
      isScreenLgOrLarger,
      isScreenXl,
      isScreenXlOrSmaller,
      isScreenXlOrLarger,
      isScreenXXL,
      isScreenXXLOrSmaller,
      isScreenXXLOrLarger,
      isScreenXXXL,
      isHoverSupported
    };
    $[31] = isScreenLargeOrSmaller;
    $[32] = isScreenLg;
    $[33] = isScreenLgOrLarger;
    $[34] = isScreenMd;
    $[35] = isScreenMdOrLarger;
    $[36] = isScreenMdOrSmaller;
    $[37] = isScreenSm;
    $[38] = isScreenSmOrLarger;
    $[39] = isScreenSmOrSmaller;
    $[40] = isScreenXXL;
    $[41] = isScreenXXLOrLarger;
    $[42] = isScreenXXLOrSmaller;
    $[43] = isScreenXXXL;
    $[44] = isScreenXl;
    $[45] = isScreenXlOrLarger;
    $[46] = isScreenXlOrSmaller;
    $[47] = isScreenXs;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  return t16;
}